import { Pipe, PipeTransform } from '@angular/core';
import { FormGroup } from '@angular/forms';

/**
 * getFormGroup
 *
 * This pipe can be used to select a FormGroup in a parent FormGroup,
 * and returns the FormGroup. This avoids having to use the formGroupName directive,
 * because that directive is causing issues with ngxErrors.
 */
@Pipe({
	name: 'getFormGroup',
	standalone: true
})
export class GetFormGroupPipe implements PipeTransform {
	public transform(parentFormGroup: FormGroup, key: string): FormGroup {
		if (!parentFormGroup || typeof key !== 'string' || key.length === 0 || !parentFormGroup.get(key)) {
			return;
		}

		return parentFormGroup.get(key) as FormGroup;
	}
}
